const newLinesRegExp = new RegExp(/\r|\n/gm);
const nonNumberRegExp = new RegExp(/[^\d.-]/g);
const trailingDots = new RegExp(/\.*$/g);
const nonLastDot = new RegExp(/\.(?=.*\.)/g);
const nonFirstMinus = new RegExp(/(.)-+/g);

export function CleanNumber(n: string): string {
    n = n.replace(newLinesRegExp, '');
    n = n.replace(nonNumberRegExp, '');
    n = n.replace(trailingDots, '');
    n = n.replace(nonLastDot, '');
    n = n.replace(nonFirstMinus, '$1');

    if (!n) {
        return '0';
    }

    return n;
}